import Index from './index.vue'
// import Create from './components/Create.vue'
import List from '@/modules/ReportCard/Subject/components/List.vue'
// import Edit from './components/Edit.vue'

export default [
  {
    path: 'subject',
    name: 'subject',
    component: Index,
    title: 'subject',
    redirect: { name: 'subject-list' },
    children: [
      {
        path: 'list',
        name: 'subject-list',
        component: List,
      },
      
    ],
  },
]
